export const AUTH_STATUS = "AUTH_STATUS";
export const GET_EXAMS = "GET_EXAMS";
export const GET_DOCTORS = "GET_DOCTORS";
export const GET_PATIENTS = "GET_PATIENTS";
export const GET_MONTH_PATIENTS = "GET_MONTH_PATIENTS";
export const GET_EXPENSES = "GET_EXPENSES";
export const LOGOUT = "LOGOUT";
